<template>
  <div class="tabs">
    <div class="tab" v-for="(item, i) in data" :key="i" :class="{active: item.active}" @click="$emit('set', item)">
      {{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Array
  }
}
</script>

<style lang="scss" scoped>
.tabs{
  @include box(auto, auto, relative, null, null, null, null, null, $tabs);
  @include flex(left, top, row);
  overflow: hidden;
  z-index: 3;
  .tab{
    @include box(10vw, 3vw, relative, null, null, null, null, null, $tabs);
    @include border(0.04vw, solid, $headerBorder, null, null, null, null);
    @include text(0.8vw, 500, null, null, center, $headerTitle);
    @include flex(center, center, row);
    cursor: pointer;
    text-transform: uppercase;
    &:hover{
      @include box(12vw, null, null, null, null, null, null, null, $tabsHover);
    }
    &.active{
      @include box(12vw, null, null, null, null, null, null, null, $tabsActive);
      @include text(null, null, null, null, null, $tabsActiveColor);
      cursor: default;
    }
  }
}
</style>
